import actions from './actions'

const initialState = {
  list: [],
  pagination: {},
  loading: false,
  detail: {},
  fundAccount: {},
  formErrors: {},
  addresses: [],
}

export default function writerReducer(state = initialState, action) {
  switch (action.type) {
    case actions.SET_STATE:
      return { ...state, ...action.payload }
    default:
      return state
  }
}
